import type { Dispatch } from '@reduxjs/toolkit';
import type { NavigateFunction, Location } from 'react-router-dom';
import { clearAuth } from '../store/slices/authSlice';

export const SESSION_EXPIRED_MESSAGE =
  'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';

let isExpiringSession = false;

export function buildLoginRedirectPath(pathname?: string, search?: string): string {
  if (!pathname) {
    return '/auth/login';
  }
  const currentPath = pathname + (search ?? '');
  return `/auth/login?redirect=${encodeURIComponent(currentPath)}`;
}

export function expireSession(
  dispatch: Dispatch,
  navigate: NavigateFunction,
  location?: Pick<Location, 'pathname' | 'search' | 'state'>
): void {
  if (isExpiringSession) {
    return;
  }
  isExpiringSession = true;

  dispatch(clearAuth());

  const redirectPath = buildLoginRedirectPath(location?.pathname, location?.search);

  navigate(redirectPath, {
    replace: true,
    state: {
      from: location,
      message: SESSION_EXPIRED_MESSAGE,
    },
  });

  setTimeout(() => {
    isExpiringSession = false;
  }, 100);
}

/** @internal Reset idempotency guard — for tests only */
export function resetExpireSessionGuard(): void {
  isExpiringSession = false;
}
